export default "__VITE_ASSET__DuNXaYRr__"